import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=24380fab&"
import script from "./PropertyList.vue?vue&type=script&lang=js&"
export * from "./PropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports